import { Component, Inject } from '@angular/core';

import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogModule,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { PatientService } from '../../../../services/patient.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ErrorPanelService } from '../../../../services/error-panel.service';
import { ActivePatientFieldsForAiAnalysis } from '../../../../models/patient-model';

@Component({
  selector: 'app-settings-dialog',
  standalone: true,
  templateUrl: './settings-dialog.component.html',
  styleUrls: ['./settings-dialog.component.scss'],
  imports: [
    MatDialogModule,
    MatFormFieldModule,
    MatSelectModule,
    MatButtonModule,
    FormsModule,
    MatInputModule,
  ],
})
export class SettingsDialogComponent {
  speakerOptions = [2, 3, 4, 5, 6, 7, 8, 9, 10];
  languageOptions = [
    { value: 'it', label: 'Italiano' },
    { value: 'en', label: 'Inglese' },
  ];

  constructor(
    public dialogRef: MatDialogRef<SettingsDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      patientId: string;
      numSpeakers: number;
      audioLanguage: string;
      patient: ActivePatientFieldsForAiAnalysis; // needed because we need to update the patient.num_speakers and patient.audio_language fields
    },
    private patientService: PatientService,
    private snackBar: MatSnackBar,
    private errorPanelService: ErrorPanelService
  ) {}

  onCancel(): void {
    this.dialogRef.close();
  }

  onSave(): void {
    this.patientService
      .putPatient(this.data.patientId, {
        num_speakers: this.data.numSpeakers,
        audio_language: this.data.audioLanguage,
      })
      .subscribe({
        next: () => {
          this.data.patient.num_speakers = this.data.numSpeakers;
          this.data.patient.audio_language = this.data.audioLanguage;

          this.snackBar.open('Impostazioni salvate con successo', 'Chiudi', {
            duration: 3000,
          });
          this.dialogRef.close(true);
        },
        error: (err) => {
          console.error('Error saving settings:', err);
          this.errorPanelService.showErrorSnackBar(
            'Errore nel salvataggio delle impostazioni'
          );
        },
      });
  }
}
